import { render, staticRenderFns } from "./gestioneUtente.html?vue&type=template&id=bc72df70&external"
import script from "./GestioneUtente.vue?vue&type=script&lang=js"
export * from "./GestioneUtente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports